import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfesionService {
  private baseUrl: string;

  constructor(private http: HttpClient, private config: ApiConfiguration) {
    this.baseUrl = `${this.config.rootUrl}/profesion`;
  }

  getProfesions(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/activos`);
  }

  createProfesion(name: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}`, { name });
  }

  updateProfesion(idProfession: string, name: string): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}/${idProfession}`, { name });
  }

  updateStateByIdProfession(
    idProfession: string,
    state: string
  ): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}/estado/${idProfession}`, {
      state,
    });
  }

  getAll(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}`);
  }

  getById(idProfession: number | string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${idProfession}`);
  }

  getByName(name: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/nombre/${name}`);
  }
}
